import React, { FC, forwardRef } from 'react';
import { default as MuiAvatar } from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';
import { AvatarProps } from './types';
import styles from './style';

const useStyles = makeStyles(styles);

const Avatar: FC<AvatarProps> = forwardRef<HTMLDivElement, AvatarProps>(({
  children,
  src,
  alt,
  size = 'medium',
  variant = 'circular',
  width,
  height,
  ...restProps
}, ref) => {
  const classes = useStyles({
    width,
    height,
  });

  const hasCustomSize = width || height;
  const className = classes[hasCustomSize ? 'root' : size];

  return (
    <MuiAvatar
      className={className}
      ref={ref}
      src={src}
      alt={alt}
      variant={variant}
      {...restProps}
    >
      {children}
    </MuiAvatar>
  );
});

export default Avatar;
